import { useMemo } from 'react';
import {
  DatePickerInputValue,
  RangeDatePickerInputValue,
  SelectionType,
} from '../types';
import { isEmptyRange, normalizeDate, normalizeRange } from '../utils';

export default function useRangeFromValue(
  value?: DatePickerInputValue,
  selectionType?: SelectionType,
) {
  return useMemo((): RangeDatePickerInputValue | undefined => {
    if (value === undefined || selectionType === undefined) return undefined;
    if (selectionType === 'single') return undefined;
    if (value && Array.isArray(value)) {
      if (isEmptyRange(value)) return [];
      return normalizeRange(value);
    }
    return value ? [normalizeDate(value)] : [];
  }, [value, selectionType]);
}
